import { API_URL } from "../config"
import { getToken } from "../util/validation";

const token = JSON.parse(getToken);

export async function checkDomain(domain) {

    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain': domain
        }

        const response = await fetch(API_URL + '/domain_checker/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        const responseJson = await response.json()

        if (responseJson.error) {
            return false
        }
        else {
            return responseJson
        }
    }
    catch (error) {
        return false;
    }

}

export async function checkDomainFile(file) {

    try {
        const email = localStorage.getItem('user')
        const formData = new FormData();
        formData.append('file', file);
        formData.append('email', email);

        const response = await fetch(API_URL + '/domain_checker/', {
            method: "POST",
            headers: {
                // "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: formData,
        });

        const responseJson = await response.json()

        if (responseJson.error) {
            return false
        }
        else {
            return responseJson
        }
    }
    catch (error) {
        return false;
    }

}
